import PropTypes from 'prop-types';
import React from 'react';
import colors from '#src/colors';
import theme from '#src/theme';
import styled from 'styled-components';
const SpinnerDiv = styled.div`
  text-align: center;
  flex-shrink: 0;
  display: flex;
  gap: 2px;
  & > div {
    width: ${props => props.isBig ? '8px' : '4px'};
    height: ${props => props.isBig ? '36px' : '18px'};
    border-radius: ${props => props.isBig ? '8px' : '4px'};
    border: ${props => props.isBig ? `${theme.borderThickness}px solid black` : '1px solid black'};
    -webkit-animation: sk-bouncedelay 1.0s infinite ease-in-out both;
    animation: sk-bouncedelay 1.2s infinite ease-in-out both;
  }
`;
const Bounce1 = styled.div`
  -webkit-animation-delay: -0.2s !important;
  animation-delay: -0.8s !important;
  background-color: ${colors.primary};
`;
const Bounce2 = styled.div`
  -webkit-animation-delay: -0.1s !important;
  animation-delay: -0.4s !important;
  background-color: ${colors.secondary};
`;
const Bounce3 = styled.div`
  background-color: ${colors.thirdColor};
`;
const Spinner = ({
  style,
  isBig,
  className
}) => /*#__PURE__*/React.createElement(SpinnerDiv, {
  isBig: isBig,
  className: className,
  style: style
}, /*#__PURE__*/React.createElement(Bounce1, null), /*#__PURE__*/React.createElement(Bounce2, null), /*#__PURE__*/React.createElement(Bounce3, null));
Spinner.defaultProps = {
  style: {}
};
Spinner.propTypes = {
  style: PropTypes.object,
  isBig: PropTypes.bool,
  className: PropTypes.string
};
export default Spinner;